import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-team',
  templateUrl: './page-team.component.html',
  styleUrls: ['./page-team.component.css'],
  standalone: false,
})
export class PageTeamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
